export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto lg:mx-0">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-6">
            Votre réparateur de fenêtre à Saverne
          </h2>
          <div className="space-y-4 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Saverne, nichée au pied du massif des Vosges, est une ville au riche passé. Entre les belles demeures bourgeoises du XIXe siècle et les résidences contemporaines, les fenêtres sont aussi variées que l'histoire locale. Nous réparons chez vous, pièce comprise, déplacement offert.
            </p>
            <p>
              Saverne, nichée au pied des Vosges, est une ville au riche passé. Les belles demeures bourgeoises du XIXe siècle côtoient les immeubles du centre-ville et les lotissements récents. Le parc immobilier est très varié, et les fenêtres aussi. Nous connaissons parfaitement les spécificités de chaque type.
            </p>
            <p>
              Que vous habitiez une résidence près du Château des Rohan ou un pavillon à l'entrée de la ville, nous nous déplaçons gratuitement. Nous réparons le mécanisme dans plus de 90 % des cas, sans remplacer la fenêtre entière. C'est plus rapide, plus écologique et bien plus économique. Devis gratuit, pièce comprise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}